import { WalletCard } from '@givebacks/api/backer';
import { useNavigate } from 'react-router-dom';
import { EventWalletCard } from 'ui';

interface ConsumerWalletEventProps {
  walletCard: WalletCard;
}
const ConsumerWalletEvent = ({ walletCard }: ConsumerWalletEventProps) => {
  const navigate = useNavigate();

  if (!walletCard.event) return null;

  return (
    <EventWalletCard
      ticketCount={walletCard.event.ticket_count}
      imageSrc={walletCard.event.image_url}
      eventName={walletCard.event.name ?? ''}
      startingAt={walletCard.event.first_ticket_at}
      endingAt={walletCard.event.last_ticket_at}
      onClick={() =>
        navigate(`${walletCard?.event?.uuid}?cause_id=${walletCard?.event?.cause_id}`)
      }
    />
  );
};

export { ConsumerWalletEvent };
